import React from 'react';

import { Product } from 'types/Product';

type ProductsMap = Record<number, Product>;

interface ExhibitionContext {
  productsMap: ProductsMap;
}

const ExhibitionContext = React.createContext({} as ExhibitionContext);

export const ExhibitionProvider: React.FCWithChildren<{ productsMap: ProductsMap }> = ({
  children,
  productsMap,
}) => {
  const ctx = {
    productsMap,
  };

  return <ExhibitionContext.Provider value={ctx}>{children}</ExhibitionContext.Provider>;
};

export const useExhibition = () => React.useContext(ExhibitionContext);

export default ExhibitionContext;
